import {Field, Formik, FormikHelpers as FormikActions} from 'formik';
import React from 'react';
import {Button} from '~/components/Button';
import {EditorField, Form, FormColumn, FormControls, FormRow, FormTitle} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';
import {prettyJSON} from '~/lib/json';
import {defaultGlobalConfig, GlobalConfig, GlobalConfigurationSchema} from '~/modules/Clients/models/GlobalConfig';

interface IGlobalSellerConfigFormProps {
    configuration?: GlobalConfig;
    onSubmit?: (values: GlobalConfig, formikActions: FormikActions<GlobalConfig>, close: IModalComponentClose) => void;
}

export const GlobalSellerConfigForm: IModalComponent<IGlobalSellerConfigFormProps> = props => {
    const globalConfig = props.configuration || defaultGlobalConfig;
    return <Formik initialValues={{...globalConfig, config: prettyJSON(JSON.stringify(globalConfig.config))}}
        validationSchema={GlobalConfigurationSchema}
        onSubmit={(values, actions) => props.onSubmit(values, actions, props.close)}
    >
        {({isSubmitting}) => <Form>
            <FormTitle>Global config</FormTitle>
            <FormRow>
                <FormColumn>
                    <Field name='config'
                        options={{
                            mode: 'json',
                            disabled: isSubmitting,
                            canFullScreen: true
                        }}
                        component={EditorField}
                    />
                </FormColumn>
            </FormRow>
            <FormControls>
                <Button disabled={isSubmitting}
                    onClick={props.close}
                >Cancel</Button>
                <Button type='submit'
                    disabled={isSubmitting}
                    intent={Intent.PRIMARY}
                    rightIcon={isSubmitting && <i className='fa fa-spinner fa-spin'/>}
                >Save</Button>
            </FormControls>
        </Form>}
    </Formik>;
};
